<template>
  <div class="modal modal-fullscreen modal-filter-details fade" id="modal-tag-node-add-talent" role="dialog" aria-labelledby="shortlist-modal-label" aria-hidden="true">
    <div class="modal-dialog" data-backdrop="true" data-keyboard="true">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="shortlist-modal-label">
            <template v-if="$userIsAdmin">Select Stars</template>
          </h4>
        </div>
        <div class="modal-body">
          <div>
            <input placeholder="Search..." v-model="search" @keypress.enter="getTalent">
            <div class="input-group-btn">
              <ladda-button
                ref="search"
                class="btn btn-dark"
                type="submit"
                :click="getTalent">
                Search
              </ladda-button>
            </div>
          </div>
          <div>
            <div id="talent-list" v-for="talent in searchTalent" :key="talent.id" style="padding: 5px;">
              <input :id="'talent-checkbox-' + talent.id" type="checkbox" :value="talent.id" v-model="selectedTalent">
              <label :for="'talent-checkbox-' + talent.id">{{ talent.name }}</label>
            </div>
            <lazy-loading
              scroll-target="#modal-tag-node-add-talent"
              class="text-center m-b-md"
              :loading="searching"
              :reached-bottom="getNextTalent"
              ref="lazyLoading">
              <div slot="loading" class="pickstar-loading"></div>
              <span slot="finished"></span>
            </lazy-loading>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-lg btn-danger pull-left" data-dismiss="modal" @click="handleModalClose"><i class="fa fa-close"></i> Cancel</button>
          <ladda-button
            type="button"
            class="btn btn-lg btn-primary"
            :click="saveTalent">
            <i class="fa fa-check"></i> Add
          </ladda-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from 'utils'
import LazyLoading from 'codium-lazy-loading'
import $ from 'jquery'

export default {
  data () {
    return {
      search: '',
      selectedTalent: [],
      searchTalent: [],
      pagination: {},
      searching: false
    }
  },

  components: {
    LazyLoading
  },

  mounted () {
    this.getTalent()
  },

  methods: {
    getTalent () {
      this.searching = true
      return http.get('talent', { params: { keywords: this.search } }).then(response => {
        this.searchTalent = response.data.data
        this.pagination = response.data.meta
        this.searching = false
      })
    },

    getNextTalent () {
      this.searching = true
      return http.get('talent', { params: { keywords: this.search, page: this.pagination.current_page + 1 } }).then(response => {
        this.searchTalent = this.searchTalent.concat(response.data.data)
        this.pagination = response.data.meta
        this.searching = false
      })
    },

    handleModalClose () {
      $(this.$el).modal('hide')
    },

    saveTalent () {
      this.$emit('add', this.selectedTalent)
      $(this.$el).modal('hide')
    }
  }
}
</script>
